<template>
  <div class="d-flex justify-content-center title-wrapper">
    <div
      class="d-flex breakpoint-xl px-3"
      :class="{
        'flex-column': $vuetify.breakpoint.xs,
      }"
    >
      <div class="d-flex align-center">
        <VIcon
          :x-large="!$vuetify.breakpoint.xs"
          :class="{ 'py-4': $vuetify.breakpoint.xs }"
        >
          {{ icon }}
        </VIcon>
        <span class="heading-6 pl-4">
          {{ $t(title) }}
        </span>
      </div>
      <VTabs
        slider-color="brandingPrimary"
        :fixed-tabs="$vuetify.breakpoint.xs"
        :show-arrows="$vuetify.breakpoint.xs"
      >
        <VTab
          v-for="item in items"
          :key="item.route"
          :to="item.route"
          :value="item.name"
          class="text-decoration-none"
          active-class="brandingPrimary--text"
        >
          <div class="body-1">
            {{ item.name }}
          </div>
        </VTab>
      </VTabs>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'UserLayoutTopMenu',
};
</script>

<script setup lang="ts">
defineProps({
  title: {
    type: String,
    required: true,
  },
  icon: {
    type: String,
    required: true,
  },
  items: {
    type: Array,
    default: () => [],
  },
});
</script>

<style lang="scss">
@import "@/style/variables.scss";

.title-wrapper {
  background-color: var(--v-cardBg-base);
}

.v-tabs {
  flex: unset !important;
  width: unset !important;

  @media screen and (min-width: 600px) {
    .v-slide-group__wrapper {
      margin: 0 0 0 60px !important;
    }
  }
}

.v-slide-group__next,
.v-slide-group__prev {
  min-width: 30px;
}

.v-slide-group__wrapper {
  .v-tab {
    white-space: nowrap !important;
  }
}
</style>
